import { Link, useParams } from 'react-router-dom'
import { isEmpty } from 'lodash'
import IconButton from '@mui/material/IconButton'
import CircularProgress from '@mui/material/CircularProgress'
import StorageIcon from '@mui/icons-material/Storage'
import { useNodeTasks } from '../../../contexts/NodeTasksContext'

function TasksIndicator() {
  const { teamSlug } = useParams()
  const { activeTaskByServiceId } = useNodeTasks()

  const hasActiveTasks = !isEmpty(activeTaskByServiceId)

  return (
    <IconButton
      component={Link}
      to={`/teams/${teamSlug}/tasks`}
      sx={{ color: 'rgba(255,255,255,0.7)', '&:hover': { color: '#fff' } }}
    >
      {hasActiveTasks ? (
        <CircularProgress size={24} sx={{ color: 'inherit' }} />
      ) : (
        <StorageIcon />
      )}
    </IconButton>
  )
}

export default TasksIndicator
